import dayjs from 'dayjs';

import { ValueEditorInputProps } from './useValueEditor';

interface UseDateEditorReturnProps {
  getDateEditorValue: (i?: number) => Date | null;
  handleDateEditorValueChange: (i?: number) => (value: Date | null) => void;
}

export const useDateEditor = ({
  values,
  handleSingleValue,
  handleMultipleValues,
}: ValueEditorInputProps): UseDateEditorReturnProps => {
  return {
    getDateEditorValue: (i = 0) => {
      const value = values?.[i];
      if (value && dayjs(value).isValid()) {
        return new Date(value);
      }

      return null;
    },
    handleDateEditorValueChange: (i) => {
      if (i === undefined) {
        return (date) => handleSingleValue(date ? date.toISOString() : null);
      }

      return (date) => handleMultipleValues(date ? date.toISOString() : null, i);
    },
  };
};
